import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
const blocks = [{
  subtitle: "DATA PRIVACY & COMPLIANCE",
  title: "Contact Information",
  text: "At FETC, we collect essential contact details to facilitate professional communication and service delivery. This includes your full name, corporate email address, and primary phone number. This information is strictly used to respond to your inquiries and provide the enterprise-level support your organization requires for complex technical solutions."
}, {
  subtitle: "CONSULTATION INQUIRIES",
  title: "Form Submissions",
  text: "When you engage with our consultation inquiry forms, we capture specific data points related to your business needs and project requirements. This structured data allows our senior consultants to prepare tailored insights and strategic recommendations before our initial engagement, ensuring a highly efficient and productive discovery process."
}, {
  subtitle: "DATA RIGHTS & COMPLIANCE REQUESTS",
  title: "Website Analytics",
  text: "To continuously improve our digital experience, we collect anonymized analytics data from our website visitors. This includes technical information such as browser types, page interaction metrics, and navigation patterns. This data helps us optimize our platform's performance and ensure that our technical insights are easily accessible to our global partners."
}];
export default function InformationWeCollect() {
  return <section data-section-id="261363" id="information-we-collect" className="py-14 md:py-18 lg:py-20 bg-[#0B1220] text-foreground scroll-mt-[120px] min-h-screen flex items-center snap-start">
      <div className="max-w-7xl mx-auto px-6 w-full">
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
          {blocks.map((block, i) => <li key={i} data-index={i} className="list-none h-full w-full">
              <Card className="bg-[#142033] border-[#13B8C8]/18 shadow-md h-full transition-all duration-300 hover:border-[#13B8C8]/50 rounded-lg w-full">
                <CardContent className="p-4 md:p-6">
                  <div className="flex flex-col items-start h-full">
                    {block.subtitle && <span className="text-[10px] md:text-xs font-mono font-bold tracking-[0.2em] text-[#F8FAFC] uppercase mb-4 border-l-2 border-[#13B8C8] pl-3">
                        {block.subtitle}
                      </span>}
                    {block.title && <h2 className="text-lg md:text-xl font-default font-semibold text-[#F8FAFC] mb-2 leading-tight">
                        {block.title}
                      </h2>}
                    <p className="text-[#F8FAFC] leading-relaxed text-sm md:text-base font-default">
                      {block.text}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </li>)}
        </ul>
      </div>
    </section>;
}